/* ******************** NPM ******************** */
// jQuery
import "./base/_jquery-global.js";

// Popper.js (* tooltip, popover, dropdown)
import * as Popper from "@popperjs/core";

// Use following imports only where needed (not globally)
// Bootstrap modules (add as needed)
// import "bootstrap/js/dist/collapse";

// Glidejs
// import Glide from "@glidejs/glide";
// window.Glide = Glide;

import stripeNavModernizrInit from "../lib/stripe-navigation/js/modernizr-custom.js";
stripeNavModernizrInit();

import stripeNavMainInit from "../lib/stripe-navigation/js/main.js";
stripeNavMainInit();

import slickInit from "../lib/slick-slider/slick.js";
slickInit();

/* ******************** BASE ******************** */
// Import utilities as needed
import {
    utl_setFooterYear,
    utl_handleModalClose,
    utl_ehElements,
    // utl_toggleCookiesAlert,
    // utl_anchorScrollOffset,
} from "./base/_utils";

// Call utility functions after imported
utl_setFooterYear();
utl_handleModalClose();
utl_ehElements();
// utl_toggleCookiesAlert();
// utl_anchorScrollOffset();

import carouselsInit from "./components/_carousels.js";
document.querySelector(".carousel") && carouselsInit();

/* ******************** COMPONENTS ******************** */
import customInit from "./components/_custom.js";
customInit();

/* ******************** PAGES ******************** */
// Individual page scripts are added in the header of specific page's index file
